// extracted by mini-css-extract-plugin
export default {"pointsBoard":"PointsBoard_pointsBoard__jusqT","selectedPoint":"PointsBoard_selectedPoint__eSeTX"};